export default {
      id: "mail-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "assets/icons/icon-sprite.svg#mail-usage",
      toString: function () {
        return this.url;
      }
    }